let szenedata = 1;
import { sitePos } from "./sitepos";

sitePos(szenedata);